export const SAVE = '@formPorfile/SAVE';
export const FETCH = '@formPorfile/FETCH';
export const REMOVE = '@formPorfile/REMOVE';

export const UPDATEFORMYPROFILE = '@formPorfile/UPDATEFORMYPROFILE';
export const UPDATEFORMYDATABANK = '@formPorfile/UPDATEFORMYDATABANK';
